export const nav = 89724;
import FormSubmissionPrompt from "webforms/formio/formio-submission-prompt";

export const getStates = (menu = "formio", other) => {
	const base = menu || "formio";
	return {
		[base]: {
			nav,
			menu, // <ui-view/>
			icon: "pencil-square-o",
			title: "Forms",
			url: "/" + base, // + "?uploaded&mode",
			params: {},
			rerouteTo: `${base}.list`,
			templateProvider: ($stateParams) => `<formio-container />`,
			...other,
		},
		[`${base}.submissions`]: {
			menu: base,
			nav: false,
			url: "/submissions/{formioId:[^/]+}",
			title: "Submissions",
			templateProvider: ($stateParams) =>
				`<formio-submissions formio-id="'${$stateParams.formioId}'" />`,
		},
		[`${base}.form`]: {
			menu: base,
			nav: false,
			url: "/form/{formioId:[^/]+}?submissionId",
			title: "Form",
			templateProvider: ($stateParams) =>
				`<form-submission formio-id="'${$stateParams.formioId}'" submission-id="${$stateParams.submissionId}" />`,
		},
		[`${base}.forms`]: {
			menu: base,
			nav: false,
			icon: "pencil-square-o",
			url: "/forms",
			title: "Forms",
			templateProvider: ($stateParams) =>
				`<form-submissions />`,
		},
		[`${base}.submission`]: {
			menu: base,
			nav: false,
			url: "/submissions/{formioId:[^/]+}",
			title: "Submissions",
			onEnter: ($stateParams) => {
				return FormSubmissionPrompt($stateParams);
			},
		},
		[`${base}.list`]: {
			menu: base,
			nav: false,
			icon: "usd",
			title: "List",
			templateProvider: ($stateParams) => `<formio-list  />`,
		},
		// [`${base}.create`]: {
		//   menu: base,
		//   nav: false,
		//   url: "/create",
		//   title: "Create New",
		//   templateProvider: ($stateParams) => `<formio-details formio-id="" />`,
		// },
		[`${base}.detail`]: {
			menu: base,
			nav: false,
			url: "/{formioId:[^/]+}",
			title: "Detail",
			params: {},
			resolve: {
				formioId: ($window, $stateParams) => $stateParams.formioId,
			},
			templateProvider: ($stateParams) =>
				`<formio-details formio-id="'${$stateParams.formioId}'" />`,
		},
		[`${base}.demo`]: {
			nav,
			landing: true,
			title: "Formio Demo",
			url: "/demo?formId",
			params: {},
			// rerouteTo: `${base}.list`,
			// authorize: s => s.hasPermission("ViewCatalogs"),
			templateProvider: ($stateParams) => `<formio-browser  />`,
			...other,
		},
	};
};

export default getStates();
